module.exports = __webpack_public_path__ + "img/1536286775.23dc5ea8.jpg";